//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { EditorState, Modifier, SelectionState } from 'draft-js';

import { ISmartInputContext } from '@components/molecules/smart-input/SmartInputContext';
import { getCurrentStateProperties } from '@components/molecules/smart-input/smartInputUtils';

/**
 * Updates the current url with the new url
 *
 * @param link The url string to be added
 * @param smartInputContext
 * @param position
 */
export const insertLinkAtPosition = (
  link: string,
  smartInputContext: ISmartInputContext,
  position: {
    blockKey: string;
    start: number;
    end: number;
  },
) => {
  const { blockKey, end, start } = position;
  const editorState = smartInputContext.editor.getEditorState();

  const { currentContentState } = getCurrentStateProperties(editorState);
  const selection = SelectionState.createEmpty(blockKey).merge({
    anchorOffset: start,
    focusOffset: end,
  });

  smartInputContext.editor.setEditorState(
    EditorState.forceSelection(editorState, selection),
  );

  const replacedContent = Modifier.replaceText(
    currentContentState,
    selection,
    link,
  );

  const newEditorState = EditorState.push(
    editorState,
    replacedContent,
    'insert-fragment',
  );

  smartInputContext.editor.setEditorState(
    EditorState.forceSelection(
      newEditorState,
      replacedContent.getSelectionAfter(),
    ),
    true,
  );

  return Promise.resolve();
};
